// plausible.service.ts
import { Injectable } from '@angular/core';

declare global {
  interface Window {
    plausible?: (
      event: string,
      options?: { u?: string; props?: Record<string, string> }
    ) => void;
  }
}

// @Injectable()
// export class PlausibleService {
//   trackPageview(url: string) {
//     if (window.plausible) {
//       window.plausible('pageview', { u: url });
//     }
//   }

//   trackEvent(eventName: string, props?: Record<string, string>) {
//     if (window.plausible) {
//       window.plausible(eventName, props ? { props } : undefined);
//     }
//   }
// }

/**
 * Service for sending pageview and custom event analytics to Plausible.
 * @injectable
 * @providedIn root
 * @example
 *   constructor(private plausibleService: PlausibleService) {}
 * @method trackPageview(url: string) - Tracks a pageview event for the given URL when Plausible is available on the window object.
 * @method trackEvent(eventName: string, props?: Record<string, string>) - Tracks a custom analytics event with optional string properties when Plausible is available on the window object.
 */
@Injectable({
  providedIn: 'root',
})
export class PlausibleService {
  trackPageview(url: string) {
    if (window.plausible) {
      window.plausible('pageview', { u: url });
    }
  }

  trackEvent(eventName: string, props?: Record<string, string>) {
    if (window.plausible) {
      window.plausible(eventName, props ? { props } : undefined);
    }
  }
}

